"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    text: {
      fontSize: '14px!important',
      display: 'inline'
    },
    bold: {
      fontWeight: '600!important'
    },
    or: {
      margin: '0 auto',
      borderRadius: '100%',
      textTransform: 'uppercase',
      fontSize: 8,
      color: palette.text.primary,
      width: 24,
      height: 24,
      border: "solid 1px var(--Tundora-20)",
      background: "var(--Tundora-10)",
      lineHeight: '24px',
      textAlign: 'center'
    }
  };
});

var NeedMoreInfo = function NeedMoreInfo(_ref2) {
  var contact = _ref2.contact,
      adminNote = _ref2.adminNote,
      onSubmit = _ref2.onSubmit,
      onCancelGift = _ref2.onCancelGift,
      isLoading = _ref2.isLoading,
      errors = _ref2.errors;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      info = _useState2[0],
      setInfo = _useState2[1];

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H3-Chambray"
  }, "Requires your attention"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Regular-Left-Inactive', classes.text),
    dangerouslySetInnerHTML: {
      __html: adminNote
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.TextAreaField, {
    rows: 5,
    fullWidth: true,
    value: info,
    onChange: function onChange(e) {
      setInfo(e.target.value);
    },
    name: "info",
    errors: errors,
    placeholder: "Are there any more details about ".concat(contact.firstName, "?")
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    width: "100%",
    disabled: isLoading || info.length === 0,
    onClick: function onClick() {
      return onSubmit(info);
    }
  }, "Submit more info")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.or
  }, "or")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.BaseButton, {
    width: "100%",
    borderColor: "var(--Tundora-20)",
    onClick: onCancelGift
  }, "Cancel this gift")));
};

NeedMoreInfo.propTypes = {
  contact: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  onCancelGift: _propTypes.default.func.isRequired,
  adminNote: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object,
  isLoading: _propTypes.default.bool
};
NeedMoreInfo.defaultProps = {
  adminNote: '',
  isLoading: false,
  errors: {}
};
var _default = NeedMoreInfo;
exports.default = _default;